import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { Fragment } from 'react';
import { AppliedFilterValueList } from './AppliedFilterValueList.tsx';
import type { AudienceAppliedFilterDisplay } from './getAudienceAppliedFiltersDisplay.ts';

type AudienceAppliedFiltersSummaryProps = {
  appliedFilters: AudienceAppliedFilterDisplay[];
};

export const AudienceAppliedFiltersSummary = ({ appliedFilters }: AudienceAppliedFiltersSummaryProps) => {
  if (appliedFilters.length === 0) {
    return null;
  }

  return (
    <Stack
      direction="row"
      data-test="audience-details-applied-filters"
      sx={{
        flexWrap: 'wrap',
        alignItems: 'center',
        columnGap: 0.5,
        rowGap: 0.5,
      }}
    >
      {appliedFilters.map((filter, index) => (
        <Box key={filter.label} component="span" sx={{ display: 'inline-flex', alignItems: 'center' }}>
          {index > 0 && (
            <Typography component="span" variant="body1" sx={{ color: 'text.secondary', mx: 0.5 }}>
              {' | '}
            </Typography>
          )}
          <Typography component="span" variant="body1Bold" sx={{ color: 'text.secondary' }}>
            {filter.label}:{' '}
            <Tooltip
              title={
                <Stack>
                  {filter.values.map((value, index) => (
                    <Fragment key={`${value.type ?? 'value'}-${value.display}`}>
                      {index === 0 && value.type && (value.type === 'State' || value.type === 'DMA') && (
                        <Typography component="span" variant="body1Bold">
                          Location type: {value.type}
                        </Typography>
                      )}
                      <Typography component="span" variant="body1" sx={{ m: 0, p: 0 }}>
                        - {value.display}
                      </Typography>
                    </Fragment>
                  ))}
                </Stack>
              }
            >
              <Typography component="span" variant="body2" sx={{ color: 'text.secondary', fontWeight: '400' }}>
                <AppliedFilterValueList values={filter.values} />
              </Typography>
            </Tooltip>
          </Typography>
        </Box>
      ))}
    </Stack>
  );
};
